import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['link']
  static values = { url: String }

  navigate(event) {
    if (event.metaKey) {
      // Handle meta key click (cmd/ctrl depending on OS) for new window behavior
      window.open(this.href, '_blank')
    } else {
      window.location.href = this.href
    }
  }

  get href() {
    return this.hasUrlValue ? this.urlValue : this.linkTarget.href
  }
}
